import React from 'react'

import ShopOne from '../ShopOne'

function Store() {
    return <ShopOne />
}

export default Store
